export const searchData = (e, projects, setResult) => {
    setResult(
        projects?.filter(dataContainsTerm(e))
    );
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.ProspectName?.toString().toLowerCase().includes(word) &&
            startsWith(data.ProspectName?.toString().toLowerCase(), word)) {
                return true;
        } else if (data.ProspectContent?.toString().toLowerCase().includes(word) || 
            startsWith(data.ProspectContent?.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}